// extracted by mini-css-extract-plugin
export default {"categorybar":"Categorybarbtn_categorybar__E6KTt"};